import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DISPLAY_LANG } from '../../../config';
import axios from "../../../axios";
import Loading from "../../../components/loading";
import "../../../stylesheets/ssl-sold-list.css";

const pageData = {
    title: {
        en: "My SSL Certificates",
        ru: "Мои SSL сертификаты",
        am: "Իմ SSL վկայագրերը",
    },
    viewButton: {
        en: "View",
        ru: "Просмотр",
        am: "Դիտել",
    },
    emptyMessage: {
        en: "No SSL certificates found",
        ru: "SSL сертификаты не найдены",
        am: "SSL վկայագրեր չեն գտնվել",
    },
};

export default function SoldSSLList() {
    const userId = localStorage.getItem("user_id");
    const [sslList, setSslList] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadingData = async () => {
            try {
                const res = await axios.get(`users/get-sold-ssl-by-user-id/${userId}`);
                console.log("FETCH SOLD SSLS:", res.data);
                setSslList(res.data);
            } catch (err) {
                console.error("FETCH SOLD SSLS ERROR:", err);
                setLoading(false);
            } finally {
                setLoading(false);
            }
        };

        loadingData();
    }, [userId]);

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="SoldSSLListPage wrapper">
            <h1>{pageData.title[DISPLAY_LANG]}</h1>

            {!!sslList?.length && (
                <div className="ssl-list">
                    {sslList.reverse().map((ssl, index) => (
                        <div className="ssl-item" key={index}>
                            <div className="ssl-info">
                                <p className="ssl-product">{ssl.productName}</p>
                                <p className="ssl-domain">{ssl.commonName}</p>
                            </div>

                            <Link to={`/user/ssl/${ssl.id}`} className="ssl-view-btn">
                                {pageData.viewButton[DISPLAY_LANG]}
                            </Link>
                        </div>
                    ))}
                </div>
            )}

            {!sslList?.length && (
                <div className="ssl-empty">
                    <p>{pageData.emptyMessage[DISPLAY_LANG]}</p>
                </div>
            )}
        </div>
    );
}
